import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements OnInit {

  constructor() { }

  @Input() section : string;
  @Input() title : string;
  @Input() message : string;
  @Input() id : string;
  @Output() confirm = new EventEmitter<string>();
  
  ngOnInit() {
  }

 ngAfterViewInit() {
    // Mueve el modal al <body> para evitar que quede atrapado en padres con overflow:hidden
    const modalElement = document.querySelector('#modal-confirm-' + this.id);
    if (modalElement && document.body) {
      document.body.appendChild(modalElement);
    }
  }
  onConfirm(){
    this.confirm.emit(this.id);
  }

}
